import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { IoLocationSharp } from "react-icons/io5";
import { GoogleMap, MarkerF, useLoadScript } from "@react-google-maps/api";
import { defaultLat, defaultLng, googleAPIKeys } from "common/utils";

const SelectOnMap = ({ setFieldValue, t }) => {
  const [show, setShow] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [center, setCenter] = useState({ lat: defaultLat, lng: defaultLng });
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: googleAPIKeys,
  });

  const handleMapClick = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setSelectedLocation({ lat, lng });
    setFieldValue("latitude", lat);
    setFieldValue("longitude", lng);
    setCenter({ lat, lng }); // handleClose();
  };

  return (
    <div>
      <Button
        variant="primary"
        className="w-100"
        style={{ height: 46 }}
        onClick={handleShow}
      >
        <IoLocationSharp /> {t("Select on Map")}
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div style={{ height: 500 }}>
            {!isLoaded ? (
              <h1>{t("Loading")}...</h1>
            ) : (
              <GoogleMap
                mapContainerClassName="map-container"
                center={center}
                zoom={10}
                onClick={handleMapClick} // Add onClick event handler
              >
                <MarkerF position={center} />
              </GoogleMap>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            {t("Done")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};


export default SelectOnMap;
